import { Component, Event, EventEmitter, getAssetPath, h, Host, Prop, State } from '@stencil/core';

import wcShared from '@web-components/shared';

import { SectionName, SupportPremiumLevelId } from '../../../utils/enum';
import helpdeskCommon from '../../../utils/HelpdeskCommon.class';
import { InitStore } from '../../../utils/Stores/init-store';
import { MessagesStore } from '../../../utils/Stores/messages-store';
import { SectionStore } from '../../../utils/Stores/section-store';
import { Store } from '../../../utils/Stores/store';
import { getPhoneWaitingTime } from '../../../utils/utils';

@Component({
  tag: 'contact-module',
  styleUrl: 'contact-module.scss',
  shadow: true,
})
export class ModuleContact {
  @Prop() readonly reload: boolean;
  @State() loaderMail = false;
  @State() loaderApi = false;
  @State() jelasticEnv: string[] = [];

  @Event() getInitEvent: EventEmitter;
  @Event() sectionChangeEvent: EventEmitter<IWCContextClose[]>;
  @Event() closeEvent: EventEmitter;

  private phoneWaitingTime = getPhoneWaitingTime();
  private setIntervalInit;
  private messages: IWCChatMessage[] = [
    {
      title: wcShared?.translate('Comment souhaitez-vous etre mis en relation ?'),
      action: null,
      type: null,
      sender_type: 'bot',
      created_at: Date.now(),
      messages: [],
      hide_sender: false,
      hide_time: true,
      disabled_input: true,
    },
  ];
  private lang = wcShared?.store?.utils?.getLang();
  private availability: IWCAvailability = {
    days: 7,
    hour: {
      from: wcShared?.store?.utils?.pmToAm('06:00', this.lang, false),
      to: wcShared?.store?.utils?.pmToAm('17:50', this.lang, false),
    },
  };
  private phoneEnabled = true;
  private phoneVipEnabled = true;
  private onlyVipPhoneAccess = false;
  private supportLevel = Store?.get('supportPremium').supportLevel;

  componentWillLoad() {
    const summaryMessages = MessagesStore?.get('messages').slice(-1)[0] as IWCChatMessageContact;
    const actionDetails = summaryMessages.action;
    if (
      Boolean(actionDetails) &&
      actionDetails.question_type === 'tech' &&
      actionDetails.service_name === 'swiss_backup' &&
      Boolean(actionDetails.service_additional_info)
    ) {
      Store?.set('messageData', {
        ...Store?.get('messageData'),
        swiss_backup_storage: actionDetails.service_additional_info,
      });
    }

    this.loaderApi = true;
    // Get all environment
    wcShared
      ?.httpCall('GET', '/api/components/support/contact?with=*')
      .then(this.handleErrors)
      .then((res) => {
        const data = res?.data as IWCProductEnvironment;
        this.jelasticEnv = data.jelastic;
        InitStore.set('init', {
          ...InitStore?.get('init'),
          environment: data,
        });
        this.loaderApi = false;
      });

    this.handlePhoneContact();
  }

  componentDidLoad() {
    if (this.phoneEnabled) {
      this.setIntervalInit = setInterval(() => {
        helpdeskCommon?.getInit().then(() => {
          clearInterval(this.setIntervalInit);
        });
      }, 1000 * 60);
    }
  }

  private handlePhoneContact(): void {
    const type = Store?.get('messageData')?.contact_type;
    const phone = InitStore?.get('init').phone;
    const phoneSchedules = phone?.schedules;
    const phoneStates = phone?.states;
    const phoneStateGlobal = phoneStates.global;

    this.phoneVipEnabled = phoneStates.global_vip;
    this.phoneEnabled = this.phoneVipEnabled;
    this.availability.hour.from = wcShared?.store?.utils?.pmToAm(
      phoneSchedules.global?.open_at,
      this.lang,
      false,
    );
    this.availability.hour.to = wcShared?.store?.utils?.pmToAm(
      phoneSchedules.global?.close_at,
      this.lang,
      false,
    );

    if (this.supportLevel === SupportPremiumLevelId.included) {
      this.availability.days = 5;
      this.phoneEnabled = phoneStateGlobal;

      if (['tech', 'admin', 'ticketing'].includes(type)) {
        this.phoneEnabled = phoneStates[type] && phoneStateGlobal;
        this.availability.hour.from = wcShared?.store?.utils?.pmToAm(
          phoneSchedules[type]?.open_at,
          this.lang,
          false,
        );
        this.availability.hour.to = wcShared?.store?.utils?.pmToAm(
          phoneSchedules[type]?.close_at,
          this.lang,
          false,
        );
      }
    }

    this.onlyVipPhoneAccess =
      !this.phoneEnabled &&
      this.phoneVipEnabled &&
      this.supportLevel === SupportPremiumLevelId.included;
  }

  private goTo(name: IWCContextClose) {
    if (
      name === 'contact_mail' &&
      !Boolean(InitStore?.get('init')?.user?.id) &&
      !window.location.href.includes('.infomaniak.com')
    ) {
      if (
        !Boolean(InitStore?.get('init')?.user?.id) &&
        !window.location.href.includes('infomaniak.ch')
      ) {
        window.location.href = 'https://www.infomaniak.com/gtl/support.contact';
        this.loaderMail = true;
      } else {
        this.sectionChangeEvent.emit([name]);
      }
    } else {
      this.sectionChangeEvent.emit([name]);
    }
  }

  private goToSupportPremiumSales() {
    const salesUrl = [SupportPremiumLevelId.plus, SupportPremiumLevelId.pro].includes(
      this.supportLevel,
    )
      ? wcShared?.store?.productsRouting?.shop +
        '/order/support_premium/' +
        Store?.get('supportPremium').id
      : wcShared?.store?.productsRouting?.website + '/gtl/support-premium.premium';
    window.open(salesUrl, '_blank', 'noopener,noreferrer');
  }

  private handleErrors(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.json();
  }

  private openChatIntercom() {
    if (
      InitStore?.get('init').chat?.value?.chat_enabled &&
      !InitStore?.get('init')?.chat?.value?.temporarily_unavailable &&
      InitStore?.get('init')?.chat?.value?.lang[wcShared?.store?.getLang()] &&
      !InitStore?.get('init')?.is_restricted
    ) {
      // POST Statistic
      wcShared?.httpCall('PUT', '/api/components/chatbot/contact-type', {
        contact_type: 'chat',
      });
      this.loadIntercom();
      window['Intercom']('show');
      window['Intercom']('update');
      window['Intercom']('onHide', function () {
        window['Intercom']('shutdown');
      });

      if (!Store?.get('is_full')) {
        this.closeEvent.emit();
      }
    }
  }

  private typeOfMail() {
    return Store?.get('messageData')?.service_slug === 'jelastic' &&
      Store?.get('messageData')?.contact_type === 'tech' &&
      this.jelasticEnv?.length > 0
      ? this.goTo(SectionName.contact_mail_jelastic)
      : this.goTo(SectionName.contact_mail);
  }

  private loadIntercom() {
    if (!window['Intercom']) {
      // Load this part only once
      // Load the settings for Intercom
      const CURRENT_ROUTE = window['CURRENT_ROUTE'];
      window['intercomSettings'] = {
        bot_id: Store?.get('bot_id'),
        channel_id: Store?.get('channel_id'),
        email: InitStore?.get('init')?.user?.email,
        user_id: InitStore?.get('init')?.user?.id,
        user_hash: InitStore?.get('init')?.chat?.user_hash,
        name:
          InitStore?.get('init')?.user?.last_name + ' ' + InitStore?.get('init')?.user?.first_name,
        current_account_id: InitStore?.get('init')?.user?.account?.id,
        current_account_name: InitStore?.get('init')?.user?.account?.organization_name,
        is_partner: InitStore?.get('init')?.user?.account?.is_partner,
        manager_url:
          wcShared?.store?.productsRouting?.manager +
          '/v3/' +
          InitStore?.get('init')?.user?.account?.id +
          '/ng/profile',
        current_route: CURRENT_ROUTE,
        app_id: 'APP_ID_INTERCOM',
        custom_launcher_selector: '.js-chat-active',
        horizontal_padding: 20,
        vertical_padding: 20,
        hide_default_launcher: true,
        language_override: wcShared?.store?.getLang(),
      };

      // load Intercom (!!! BASIC SNIPPET HAVE BEEN MODIFIED)
      (function () {
        const w = window;
        const ic = w['Intercom'];
        if (typeof ic === 'function') {
          ic('reattach_activator');
          ic('update', w['intercomSettings']);
        } else {
          const d = document;
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const i: any = function () {
            // eslint-disable-next-line prefer-rest-params
            i.c(...arguments);
          };
          i.q = [];
          i.c = function (args) {
            i.q.push(args);
          };
          w['Intercom'] = i;
          const l = function () {
            const s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://widget.intercom.io/widget/wzjwxni4';
            const x = d.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
          };
          l();
        }
      })();
    }
  }

  private deleteSetInterval() {
    clearInterval(this.setIntervalInit);
  }

  private getSortedContactList() {
    const isChatDisabled =
      !InitStore?.get('init')?.chat?.value?.chat_enabled ||
      !InitStore?.get?.('init')?.chat?.value?.lang?.[wcShared?.store?.getLang?.()] ||
      (InitStore?.get('init')?.is_restricted && !InitStore?.get('init')?.is_my_ksuite_plus);

    const isTicketDisabled =
      !InitStore?.get('init')?.mail?.enabled || InitStore?.get('init')?.ticket_limit_reached;

    const isPhoneDisabled =
      (InitStore?.get('init')?.is_restricted && !InitStore?.get('init')?.is_my_ksuite_plus) ||
      !this.phoneEnabled;

    const chat = (
      <div
        class={{
          'contact-list-chat list-item': true,
          disabled: isChatDisabled,
        }}
        onClick={() => {
          this.openChatIntercom();
          this.deleteSetInterval();
        }}
      >
        <div class="flex">
          <div class="contact-list-chat__left">
            <img
              src={getAssetPath('./../assets/rounded-icons/icon-chat-yellow.svg')}
              alt={wcShared.translate('Icon chat')}
            />
            <div class="list-item-text">
              <div class="list-item-text__title">{wcShared?.translate('Chat')}</div>
              <div class="list-item-text__description">
                {wcShared?.translate('Échangez en direct avec notre support')}
              </div>
            </div>
          </div>
          <div
            class={{
              'contact-list-chat__right': true,
              hide:
                !InitStore?.get('init')?.chat?.value?.chat_enabled ||
                InitStore?.get('init')?.chat?.unassigned_conversation === 0,
            }}
          >
            <span>
              {InitStore?.get('init')?.chat?.unassigned_conversation}{' '}
              {InitStore?.get('init')?.chat?.unassigned_conversation > 1
                ? wcShared?.translate('Personnes')
                : wcShared?.translate('Personne')}
            </span>
            <span>{wcShared?.translate('devant vous')}</span>
          </div>
        </div>
        <div class="list-item-status">
          <span class={{ disabled: isChatDisabled }}></span>
        </div>
      </div>
    );

    const ticket = (
      <div
        class={{
          'contact-list-mail list-item': true,
          loaderMail: this.loaderMail,
          disabled: isTicketDisabled,
        }}
        onClick={() => {
          if (
            !InitStore?.get('init')?.mail?.enabled ||
            InitStore?.get('init')?.ticket_limit_reached
          ) {
            return null;
          }
          Store?.set('isFromLanding', false);
          this.typeOfMail();
          this.deleteSetInterval();
        }}
      >
        {this.loaderMail ? (
          <module-loader-component />
        ) : (
          [
            <div class="flex">
              <img
                src={getAssetPath('./../assets/rounded-icons/icon-mail-yellow.svg')}
                alt={wcShared?.translate('Icon mail')}
              />
              <div class="list-item-text">
                <div class="list-item-text__title">
                  {[
                    SupportPremiumLevelId.plus,
                    SupportPremiumLevelId.pro,
                    SupportPremiumLevelId.business,
                  ].includes(this.supportLevel)
                    ? wcShared?.translate('Ticket prioritaire')
                    : wcShared?.translate('Ticket')}
                </div>
                <div class="list-item-text__description">
                  {InitStore?.get('init')?.ticket_limit_reached
                    ? wcShared?.translate(
                        'Vous avez atteint votre quota de ticket pour le moment. Veuillez reessayer ulterieurement',
                      )
                    : wcShared?.translate('Envoyez votre demande à un(e) spécialiste')}
                </div>
              </div>
            </div>,
            <div class="list-item-status">
              <span
                class={{
                  disabled:
                    !InitStore?.get('init')?.mail?.enabled ||
                    InitStore?.get('init')?.ticket_limit_reached,
                }}
              ></span>
            </div>,
          ]
        )}
      </div>
    );

    const phone = (
      <div
        class={{
          'contact-list-phone list-item': true,
          disabled: isPhoneDisabled,
        }}
        onClick={() => {
          if (!isPhoneDisabled) {
            this.deleteSetInterval();
            this.goTo(SectionName.contact_phone);
          }
        }}
      >
        <div class={{ flex: true, 'no-width': this.onlyVipPhoneAccess }}>
          <div class="contact-list-phone__left">
            <img
              src={getAssetPath('./../assets/rounded-icons/icon-headset-yellow.svg')}
              alt={wcShared.translate('Icon phone')}
            />
            <div class="list-item-text">
              <div class="list-item-text__title">{wcShared?.translate('Telephone')}</div>
              <div class="list-item-text__description">
                {this.phoneEnabled ? (
                  wcShared?.translate('Parler avec un conseiller')
                ) : (
                  <div class="list-item-text__opening-time">
                    <div>
                      <img
                        src={getAssetPath('./../assets/icons/calendar.svg')}
                        alt="Calendar"
                      />
                      {wcShared?.translate('$count$ j. / 7', { count: this.availability?.days })}
                    </div>
                    <div>
                      <img
                        src={getAssetPath('./../assets/icons/time-clock-circle.svg')}
                        alt="Time clock"
                      />
                      {wcShared?.translate('$fromHour$ a $toHour$', {
                        fromHour: this.availability?.hour.from,
                        toHour: this.availability?.hour.to,
                      })}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            class={{
              'contact-list-phone__right': true,
              hide: !this.phoneEnabled,
            }}
          >
            {wcShared?.translate('Attente estimee')}
            <span>
              {this.phoneWaitingTime}{' '}
              {this.phoneWaitingTime > 1
                ? wcShared?.translate('minutes')
                : wcShared?.translate('minute')}
            </span>
          </div>
        </div>
        <div class="list-item-status-wrapper">
          <p
            class={{
              hide: !this.onlyVipPhoneAccess,
              'only-vip-access': true,
            }}
          >
            {wcShared?.translate('Support premium uniquement')}
          </p>
          <div class="list-item-status">
            <span
              class={{
                disabled: !this.phoneEnabled,
                'only-vip-access': this.onlyVipPhoneAccess,
              }}
            ></span>
          </div>
        </div>
      </div>
    );

    const contactList = [
      {
        content: phone,
        isDisabled: isPhoneDisabled,
      },
      {
        content: ticket,
        isDisabled: isTicketDisabled,
      },
      {
        content: chat,
        isDisabled: isChatDisabled,
      },
    ];

    return [...contactList].sort((a, b) =>
      a.isDisabled === b.isDisabled ? 0 : a.isDisabled ? 1 : -1,
    );
  }

  render() {
    if (this.loaderApi) {
      return <module-loader-component class="loader" />;
    } else if (SectionStore?.get('section')?.contact_chat) {
      return <contact-chat-module></contact-chat-module>;
    } else if (SectionStore?.get('section')?.contact_phone) {
      return (
        <contact-phone-module
          availability={this.availability}
          phoneEnabled={this.phoneEnabled}
        ></contact-phone-module>
      );
    } else if (SectionStore?.get('section')?.contact_callmeback) {
      return <contact-callmeback></contact-callmeback>;
    } else if (
      SectionStore?.get('section')?.contact_mail ||
      SectionStore?.get('section')?.contact_mail_error ||
      SectionStore?.get('section')?.contact_mail_success
    ) {
      return (
        <contact-mail-module reload={this.reload}>
          <div slot="recaptcha-slot-4">
            <slot name="recaptcha-slot-3" />
          </div>
        </contact-mail-module>
      );
    } else if (SectionStore?.get('section')?.contact_mail_jelastic) {
      return (
        <contact-mail-jelastic-module
          jelasticEnv={this.jelasticEnv}
          reload={this.reload}
        ></contact-mail-jelastic-module>
      );
    } else {
      return (
        <Host>
          <div class="contact">
            <div class="contact-context">
              <bot-messages-component messages={this.messages}></bot-messages-component>
            </div>
            <div class={{ 'contact-list': true }}>
              {/* Support busy */}
              <div
                class={{
                  'contact-list-busy list-item': true,
                  hide: !InitStore?.get('init')?.support_busy,
                }}
              >
                <div class="flex">
                  <img
                    src={getAssetPath('./../assets/icons/warning.svg')}
                    alt={wcShared.translate('Attention')}
                  />
                  <div class="list-item-text">
                    <div class="list-item-text__title">
                      {wcShared?.translate('Tous nos agents sont occupes')}
                    </div>
                    <div class="list-item-text__description">
                      {wcShared?.translate(
                        "Nous traitons actuellement beaucoup de demandes et risquons de prendre plus de temps que d'habitude pour vous repondre. Merci pour votre patience.",
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Ticket, Phone, Chat */}
              {this.getSortedContactList().map((block) => block.content)}

              {/* Critical Emergency */}
              <div
                class={{
                  'contact-list-emergency list-item': true,
                  hide: ![SupportPremiumLevelId.pro, SupportPremiumLevelId.business].includes(
                    this.supportLevel,
                  ),
                }}
                onClick={() => this.goTo(SectionName.technical_emergency)}
              >
                <div class="flex">
                  <img
                    src={getAssetPath('./../assets/rounded-icons/icon-urgence.svg')}
                    alt={wcShared?.translate('Icon warning')}
                  />
                  <div class="list-item-text">
                    <div class="list-item-text__title">
                      {wcShared?.translate('Urgence critique')}
                    </div>
                    <div class="list-item-text__description">
                      {wcShared?.translate("Reservee en cas de problemes lies a l'infrastructure")}
                    </div>
                  </div>
                </div>
                <div class="list-item-status">
                  <span class={{ disabled: false }}></span>
                </div>
              </div>

              {/* Upgrade Support Premium */}
              <div
                class={{
                  'contact-list-support-premium list-item': true,
                  hide: this.supportLevel !== SupportPremiumLevelId.included,
                }}
                onClick={() => this.goToSupportPremiumSales()}
              >
                <div class="flex">
                  <img
                    src={getAssetPath('./../assets/icons/support-premium-offer.svg')}
                    alt={wcShared?.translate('Icon support premium')}
                  />
                  <div class="list-item-text">
                    <div class="list-item-text__title">
                      {wcShared?.translate('Support Premium')}
                    </div>
                    <div class="list-item-text__description">
                      {wcShared?.translate(
                        'Donnez la priorite a vos demandes de support en souscrivant au Support Premium',
                      )}
                    </div>
                  </div>
                </div>
                <div class="list-item-status">
                  <img
                    src={getAssetPath('./../assets/icons/arrow-right.svg')}
                    alt={wcShared?.translate('Acceder')}
                  />
                </div>
              </div>
            </div>
          </div>
        </Host>
      );
    }
  }
}
